import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

Vue.use(Vuex);

import snackbar from '@/components/_global/snackbar/store';
import settings from '@/components/_global/settings/store';
import permissions from '@/components/_global/permissions/store';

const store: StoreOptions<any> = {
	state: {},
	modules: {
		snackbar,
		settings,
		permissions
	}
};

export default new Vuex.Store<any>(store);
